import React from 'react';
import ComponentErp from './ComponentErp.js';
import { getSisTipoEnd, getSisEstados } from '../services/Auth.js';
import FormEdit from '../components/FormEdit.js';
import { GetClienteEndAPI, PostClienteEndAPI } from '../models/ModelClientesEnd.js';
import { GetEnderecosAPI, GetEnderecoCepAPI } from '../models/ModelEnderecos.js';


class ClientesEnderecoUpdate extends ComponentErp {

  constructor(props) {
    super(props);
    this.state = {
      refresh: 'concluido', //0 = concluído, 1 = gravando, 2 = buscando, 3 = limpando form 
      tipo_end: getSisTipoEnd(),
      estados: getSisEstados(),
      cidades: null,
      id_cliente: this.props.id_cliente,
      id_cliente_end: this.props.id_cliente_end,
      sid_cliente_end: '',
      sid_sis_tp_end: '',
      scli_endereco: '',
      scli_numero: '',
      scli_complemento: '',
      scli_bairro: '',
      scli_cep: '',
      sid_pais: '',
      sid_estado: '',
      sid_cidade: '',
      scli_principal: ''
    }

    const script = document.createElement("script");

    script.src = "/assets/js/admin-materialize.min.js?v=1";
    script.async = true;

    document.body.appendChild(script);

  }

  componentDidMount() {
    if (this.state.id_cliente > 0 && this.state.id_cliente_end > 0) {
      this.callApiGetClienteEnd(this.state.id_cliente, this.state.id_cliente_end)
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.state.refresh === 'gravando') {
      this.callApi();
      this.setState({
        refresh: 'concluido'
      })
    }

    if (this.props.refresh === 'buscando' && this.props.id_cliente_end !== this.state.id_cliente_end) {
      this.setState({
        refresh: this.props.refresh,
        id_cliente: this.props.id_cliente,
        id_cliente_end: this.props.id_cliente_end
      })
      this.callApiGetClienteEnd(this.props.id_cliente, this.props.id_cliente_end)
    }

    if (this.props.refresh === 'limpando' && this.state.id_cliente_end > 0) {
      this.setState({
        refresh: 'concluido',
        id_cliente_end: 0,
        sid_cliente_end: '',
        sid_sis_tp_end: '',
        scli_endereco: '',
        scli_numero: '',
        scli_complemento: '',
        scli_bairro: '',
        scli_cep: '',
        sid_pais: '',
        sid_estado: '',
        sid_cidade: '',
        scli_principal: ''

      })
    }

  }

  async callApi() {
    let data =
    {
      id_cliente_end: this.state.sid_cliente_end,
      id_sis_tp_end: this.state.sid_sis_tp_end,
      cli_endereco: this.state.scli_endereco,
      cli_numero: this.state.scli_numero,
      cli_complemento: this.state.scli_complemento,
      cli_bairro: this.state.scli_bairro,
      cli_cep: this.state.scli_cep,
      id_pais: this.state.sid_pais,
      id_estado: this.state.sid_estado,
      id_cidade: this.state.sid_cidade,
      cli_principal: this.state.scli_principal
    }

    var response = await PostClienteEndAPI(this.state.id_cliente, this.state.id_cliente_end, data);
    if (response.erro === 0) {
      this.props.returnComponentRefresh();
    }
  }

  async callApiGetClienteEnd(id_cliente, id_cliente_end) {

    var response = await GetClienteEndAPI(id_cliente, id_cliente_end);
    if (response.sid_estado > 0) {
      var responseCid = await GetEnderecosAPI(response.sid_estado);
      response.cidades = responseCid.cidades;
    } else {
      response.cidades = null;
    }
    this.setState(
      response
    );
  }

  handleInputCep = (event) => {
    this.handleInputChange(event)

    if(event.target.value.length===9)
      this.callApiGetCep(event.target.value)
  }

  async callApiGetCep(cep) {
    if (cep.length=== 9) {
      var response = await GetEnderecoCepAPI(cep.replace('-',''));
      if(response.endereco!==undefined){
        this.setState({
          scli_endereco: response.endereco.endereco,
          scli_numero: '',
          scli_complemento: '',
          scli_bairro: response.endereco.bairro,
          sid_estado: response.endereco.id_estado,
          sid_cidade: response.endereco.id_cidade,
          cidades: response.cidades
          });
      }
    } else {
      this.setState(
        { cidades: null }
      );
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    this.callApi()
  }


  handleCancel = (event) => {
    event.preventDefault()
    this.props.returnComponentRefresh();
  }


  render() {

    return (
      <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">
        {<FormEdit id='id_cliente_end' typeField='hidden'
          value={this.state.id_cliente_end}
        />}

        {<FormEdit id='sid_sis_tp_end'
          label='Tipo de Endereço'
          styleDiv='2'
          onChange={this.handleInputChange}
          typeField='select'
          value={this.state.sid_sis_tp_end}
          required='on'
          optionsField={this.state.tipo_end}
        />}

        {<FormEdit id='scli_cep'
          label='CEP'
          styleDiv='2'
          onChange={this.handleInputCep}
          value={this.state.scli_cep}
          mask="cep"
          required='on'
        />}

        {<FormEdit id='scli_endereco'
          label='Endereço'
          styleDiv='1'
          onChange={this.handleInputChange}
          value={this.state.scli_endereco}
          required='on'
        />}

        {<FormEdit id='scli_numero'
          label='Número'
          styleDiv='2'
          onChange={this.handleInputChange}
          value={this.state.scli_numero}
          mask="numero"
        //required='on'
        />}

        {<FormEdit id='scli_complemento'
          label='Complemento'
          styleDiv='2'
          onChange={this.handleInputChange}
          value={this.state.scli_complemento}
        />}

        {<FormEdit id='scli_bairro'
          label='Bairro'
          styleDiv='2'
          onChange={this.handleInputChange}
          value={this.state.scli_bairro}
          required='on'
        />}

        {<FormEdit id='sid_estado'
          label='Estado'
          styleDiv='2'
          onChange={this.handleInputEstado}
          typeField='select'
          value={this.state.sid_estado}
          required='on'
          optionsField={this.state.estados}
        />}

        {<FormEdit id='sid_cidade'
          label='Cidade'
          styleDiv='2'
          onChange={this.handleInputChange}
          typeField='select'
          value={this.state.sid_cidade}
          required='on'
          optionsField={this.state.cidades}
        />}

        {<FormEdit id='scli_principal'
          label='Principal?'
          styleDiv='2'
          typeField='checkbox'
          onChange={this.handleInputChange}
          value={this.state.scli_principal}
        />}


        {<FormEdit id='cancelar'
          label='Cancelar'
          styleDiv='submit right'
          styleField='submit'
          typeField='button'
          onClick={this.handleCancel}
          icon='cancelar'
        />}

        {<FormEdit id='gravar'
          label='Gravar'
          styleDiv='submit right'
          styleField='submit'
          typeField='submit'
          icon='gravar'
        />}

      </form>

    );

  }
}

export default ClientesEnderecoUpdate;
